import { head, intersection } from 'lodash';

// Function for validation against a valid input set.
//
// Examples:
//
//    permit(1, [1, 2, 3]) => 1
//    permit(1, [2, 3]) => null
//
export default function(input, valid_inputs) {
  return head(intersection([input], valid_inputs)) || null;
}



/** WEBPACK FOOTER **
 ** ./javascripts/common/helpers/permit.js
 **/